import React from "react";
import PropTypes from "prop-types";

import Tweezer from "tweezer.js";

import VideoSectionPlaylistSwitch from "./VideoSectionPlaylistSwitch";
import VideoSectionVideo from "./VideoSectionVideo";
import VideoSectionPlaylist from "./VideoSectionPlaylist";

class VideoSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      playlistIndex: 0,
      videoIndex: 0,
    };
  }

  componentDidMount = () => {
    const { playlists } = this.props;

    const playlistId = window.location.hash.split("#")[1];
    const playlistIndex = playlists.findIndex(
      (playlist) => playlist.id === playlistId
    );

    if (playlistIndex !== -1) {
      this.setState({
        playlistIndex,
      });

      this.scrollToVideoSection();
    }
  };

  setPlaylistIndex = (playlistIndex) => {
    this.setState({
      playlistIndex: +playlistIndex,
      videoIndex: 0,
    });
  };

  setVideoIndex = (videoIndex) => {
    this.setVideSectionAsTop();
    this.setState({
      videoIndex,
    });
  };

  setVideSectionAsTop = () => {
    const twzr = new Tweezer({
      start: window.scrollY,
      end: this.container.getBoundingClientRect().top + window.scrollY,
      duration: 200,
    });

    twzr.on("tick", (value) => {
      window.scrollTo(0, value);
    });
    twzr.begin();
  };

  scrollToVideoSection = () => {
    if (this.container && window.location.hash) {
      this.setVideSectionAsTop();
    }
  };

  render = () => {
    const { title, playlists, allowTitle, overviewUrl } = this.props;

    const { videoIndex, playlistIndex } = this.state;

    const playlist = playlists[playlistIndex];

    if (!playlist) {
      return null;
    }

    const video = playlist.videos[videoIndex];

    if (!video) {
      return null;
    }

    return (
      <div
        className="video-section"
        ref={(c) => {
          this.container = c;
        }}
      >
        <div className="video-section__header">
          {allowTitle && <h2 className="video-section__title">{title}</h2>}
          <VideoSectionPlaylistSwitch
            playlists={playlists}
            playlistIndex={playlistIndex}
            setPlaylistIndex={this.setPlaylistIndex}
          />
          {overviewUrl && (
            <span className="video-section__link">
              <a className="btn is-small is-default" href={overviewUrl}>
                <span className="btn__text">Alle playlists</span>
                <svg className="btn__icon is-suffix" width="12" height="12">
                  <use xlinkHref="#arrow-right" />
                </svg>
              </a>
            </span>
          )}
        </div>
        <VideoSectionVideo video={video} />
        <VideoSectionPlaylist
          playlist={playlist}
          handleVideoClick={this.setVideoIndex}
          activeVideo={videoIndex}
        />
      </div>
    );
  };
}

VideoSection.propTypes = {
  allowTitle: PropTypes.bool,
  title: PropTypes.string.isRequired,
  overviewUrl: PropTypes.string,
  playlists: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
};

VideoSection.defaultProps = {
  allowTitle: false,
  overviewUrl: undefined,
};

export default VideoSection;
